module.exports = __webpack_public_path__ + "static/media/info-light.a4a45744.svg";